import { useTranslator } from '@bluebeam/react-i18n';
import FilterPopover from 'components/FilterPopover';
import FilterButton from 'components/FilterPopover/FilterButton';
import React, { FC, useState } from 'react';
import { Manager } from 'react-popper';
import { SheetQuery } from 'records/SheetQuery';
import querySheets from 'utils/querySheets';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import DisciplineFilterSection from './DisciplineFilterSection';
import RecentlyIssuedCheckbox from './RecentlyIssuedCheckbox';
import RevCommentFilterSection from './RevCommentFilterSection';

const DrawingsFilterPopover: FC<WithAppStoreProps> = ({
  appState,
  actions,
}) => {
  const { translate } = useTranslator(['drawingsFilterPopover']);
  const [open, setOpen] = useState(false);
  const [sheetQuery, setSheetQuery] = useState(appState.sheetQuery);

  const handleCloseClick = (): void => {
    setOpen(false);
  };

  const handleFilterClick = (): void => {
    setOpen(true);
    setSheetQuery(appState.sheetQuery);
  };

  const handleUpdateLocalSheetQuery = (nextSheetQuery: SheetQuery) => {
    setSheetQuery(nextSheetQuery);
  };

  const getFilterApplied = (): boolean => {
    const { sheetQuery } = appState;

    return (
      sheetQuery.disciplines.size > 0 ||
      sheetQuery.sheetDisciplines.size > 0 ||
      sheetQuery.revisionComments.size > 0 ||
      sheetQuery.recentlyIssued
    );
  };

  const handleReset = () => {
    const resetSheetQuery = sheetQuery
      .delete('disciplines')
      .delete('sheetDisciplines')
      .delete('disciplineSearch')
      .delete('revisionComments')
      .delete('recentlyIssued');
    setSheetQuery(resetSheetQuery);
    actions.setSheetQuery(resetSheetQuery);
  };

  const handleFilterConfirm = () => {
    actions.setSheetQuery(sheetQuery);
    setOpen(false);
  };

  const getConfirmBtnText = (): string => {
    const { sheets } = appState;

    const querySheetsResponse = querySheets(sheets, sheetQuery);
    const querySheetsSize = querySheetsResponse.size;
    if (querySheetsSize === sheets.size) {
      return translate('drawingsFilterPopover:showAllItems');
    }
    return querySheetsSize === 1
      ? translate('drawingsFilterPopover:showItem')
      : translate('drawingsFilterPopover:showItems', {
          count: querySheetsSize,
        });
  };

  return (
    <Manager>
      <FilterButton
        onFilterClick={handleFilterClick}
        filterApplied={getFilterApplied()}
      />
      <FilterPopover
        title={translate('drawingsFilterPopover:title')}
        open={open}
        onClose={handleCloseClick}
        onReset={handleReset}
        onConfirm={handleFilterConfirm}
        confirmBtnText={getConfirmBtnText()}
      >
        <RecentlyIssuedCheckbox
          sheetQuery={sheetQuery}
          updateSheetQuery={handleUpdateLocalSheetQuery}
        />
        <DisciplineFilterSection
          sheetQuery={sheetQuery}
          updateSheetQuery={handleUpdateLocalSheetQuery}
        />
        <RevCommentFilterSection
          sheetQuery={sheetQuery}
          updateSheetQuery={handleUpdateLocalSheetQuery}
        />
      </FilterPopover>
    </Manager>
  );
};

export default withAppStore(DrawingsFilterPopover);
